<template>
    <b-modal size="xl" button-size="sm" :title="prefix + ' > Tarefa'" v-model="showModal" @hidden="cancelar"
        hide-footer>
        <b-card>
            <b-card bg-variant="light">
                <div>
                    <span style="font-size: 16px;">
                        <strong>Nº Tarefa:</strong> {{ form.id }} <br>
                        <strong>Data:</strong> {{ formatarData(form.dataCriacao) }} <br>
                        <strong>Requisição:</strong> {{ form.requisicaoCompra ?
                            form.requisicaoCompra.numeroRequisicaoCompra : '' }} <br>
                        <strong>Unidade Administrativa:</strong> {{ form.departamento ? form.departamento.descricao : ''
                        }}<br>
                        <strong>Tipo de Tarefa:</strong> {{ form.tipoTarefaRequisicao ?
                            form.tipoTarefaRequisicao.descricao : '' }}<br>
                        <strong>Status:</strong> {{ form.status ? form.status.descricao : '' }} <br>
                        <strong>Responsável:</strong> {{ form.pessoa ? form.pessoa.nome : '' }} <br>

                    </span>
                </div>
            </b-card>

            <b-card bg-variant="light">
                <b-col lg="12" sm="12" class="text-left">
                    <b-form-group label-for="textarea-formatter" class="col-12">
                        <label for="textarea-auto-height">Observação:</label>
                        <b-form-textarea :disabled="isVisualizacao" v-model="form.observacao">
                        </b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-card>

            <div class="d-flex w-100 justify-content-center">
                <b-button id="salvar" variant="success" size="sm" pill class="ml-2" @click="salvar"
                    v-if="!isVisualizacao">
                    <b-tooltip target="salvar" title="Salvar"></b-tooltip>
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check2-circle" scale="1.5" />
                    </div>
                </b-button>
                <b-button id="concluir" variant="primary" size="sm" pill class="ml-2" @click="concluir"
                    v-if="!isVisualizacao">
                    <b-tooltip target="concluir" title="Finalizar Tarefa"></b-tooltip>
                    <b-icon icon="arrow-right" />
                </b-button>
                <b-button id="cancelar" variant="danger" size="sm" pill class="ml-2" @click="cancelar">
                    <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>
        </b-card>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import Formatters from "@/core/mixins/formatters";
import moment from "moment";
import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import StatusEnum from "@/core/utils/StatusEnum";

export default {
    mixins: [Formatters, ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
        isVisualizacao: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showModal: true,
            busy: false,
            form: {
                id: "",
                dataCriacao: "",
                data: "",
                observacao: "",
                responsavel: "",
                respCriacao: "",
                departamento: { descricao: "" },
                pessoa: { nome: "" },
                status: { descricao: "" },
                tipoTarefaRequisicao: { descricao: "" },
                requisicaoCompra: { numeroRequisicaoCompra: "" },
                parecer: null
            },
        };
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/tarefasrequisicao`);
        await this.carregarTarefa();
    },

    methods: {
        async carregarTarefa() {
            this.busy = true;
            const { data } = await this.$service.findById(this.id);
            this.form = data;
            this.busy = false;
        },

        formatarData(data) {
            return data ? moment(String(data)).format("DD/MM/YYYY HH:mm") : "";
        },

        async concluir() {
            if (!this.form.parecer) {
                this.$notify({
                    type: "danger",
                    message: "Selecione um parecer para finalizar a tarefa."
                });
                return;
            }

            try {
                this.busy = true;
                const updateIntent = {
                    status: this.form.parecer === "APROVADO" ? StatusEnum.TAREFA_REQUISICAO_FINALIZADA.value : StatusEnum.TAREFA_REQUISICAO_REJEITADA.value,
                    observacao: this.form.observacao
                };

                await this.$service.put(`${this.form.id}/status`, updateIntent);

                this.busy = false;
                this.$notify({
                    type: "success",
                    message: `Tarefa finalizada com sucesso.`
                });
                this.cancelar();
            } catch (error) {
                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: error.response.message
                });
            }
        },

        async salvar() {
            try {
                this.busy = true;
                await this.$service.put(this.form.id, this.form);
                this.busy = false;
                this.$notify({
                    type: "success",
                    message: "Tarefa salva com sucesso."
                });
            } catch (error) {
                this.busy = false;
                this.$notify({
                    type: "danger",
                    message: error.response.message
                });
            }
        },

        cancelar() {
            this.$emit("close");
        }
    }
};
</script>

<style scoped>
.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
